module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/readable-stream/writable.js
// module id = ../../../../readable-stream/writable.js
// module chunks = 3